function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { RouteParams } from '../../reducers/selectors/customer.selectors';
import { DASHBOARD_ROUTE } from '../../reducers/constants/dashboard.constants';
import { retrieveCustomerByExternalReference } from './acsrCustomerSwitch.actions';
import { ROOT_CARE_MODULE_ROUTE } from '../../customercare.constants';
export var AcsrCustomerSwitchController = /*#__PURE__*/function () {
  function AcsrCustomerSwitchController($state, $ngRedux, uiNotificationService) {
    _classCallCheck(this, AcsrCustomerSwitchController);
    Object.assign(this, {
      $state: $state,
      $ngRedux: $ngRedux,
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(AcsrCustomerSwitchController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          routeParams: RouteParams(store)
        };
      };
      var controllerActions = {
        retrieveCustomerByExternalReference: retrieveCustomerByExternalReference
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.loadAcsrCustomerAndRedirect();
    }
  }, {
    key: "loadAcsrCustomerAndRedirect",
    value: function loadAcsrCustomerAndRedirect() {
      var _this2 = this;
      this.actions.retrieveCustomerByExternalReference(this.state.routeParams.externalReference).then(function (response) {
        _this2.$state.go(DASHBOARD_ROUTE, {
          customerId: response.Subscriber.Id
        });
      }).catch(function (error) {
        _this2.uiNotificationService.transientError(error.translatedMessage);
        _this2.$state.go(ROOT_CARE_MODULE_ROUTE);
      });
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }]);
}();
export default {
  controller: AcsrCustomerSwitchController,
  template: require('./acsrCustomerSwitch.html')
};